export default { sha: '2e81f0e3b95db8548dd8be1ca0259a4775cc3785', buildNumber: 'undefined' }
